import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import VendorStatementMain from '../../components/AP/vendorStatementMain';
import { fetchVendorStatementList} from '../../actions/arap_actions';
import { setValue } from '../../actions/sales_actions';
import { selectVendor, resetCurrentVendor } from '../../actions/vendors_actions';

let vendorStatementMain = reduxForm({
  form: 'vendorStatementMain',
})(VendorStatementMain);

const selector = formValueSelector('vendorStatementMain');

function mapStateToProps(state) {
    const typeRadios = selector(state, 'typeRadios');
    const Days = selector(state, 'Days');
    return {
        typeRadios,
        Days,
        vendorStatementListIsLoading: state.arap.vendorStatementListIsLoading,
        vendorStatementList: state.arap.vendorStatementList,
        vendorStatementListError: state.arap.vendorStatementListError,
        currentVendor: state.vendors.currentVendor,

    };
}

export default connect(mapStateToProps, { setDefaultOfForm, fetchVendorStatementList, setValue, selectVendor, resetCurrentVendor})(vendorStatementMain);



// WEBPACK FOOTER //
// ./master/jsx/containers/AP/vendorStatementMain.jsx